import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import Counter from "@components/counter";

import BadgeNew from "../../../../BadgeNew";

import { sendNavigationMetric } from "../../../../../utils/sendMetric";

import mainMenuLinks from "../../../../../links/mainMenuLinks";

import styles from "../MainMenuDropdown.scss";

const cx = classnames.bind(styles);

const MainMenuLink = ({ name, counter, isCounterActive, isNew }) => {
  const data = mainMenuLinks[name] || {};

  return (
    <a
      href={data.href}
      className={cx("menu-link", { "is-new": isNew })}
      onClick={() => sendNavigationMetric(data.code)}
    >
      <span className={cx("menu-link-label")}>{data.label}</span>
      {!!counter && (
        <Counter
          size="large"
          className={cx("counter", { "is-counter-active": isCounterActive })}
          active={isCounterActive}
          maxValue={99}
        >
          {counter}
        </Counter>
      )}
      {isNew && <BadgeNew />}
    </a>
  );
};

MainMenuLink.propTypes = {
  name: PropTypes.string,
  counter: PropTypes.number,
  isCounterActive: PropTypes.bool,
  isNew: PropTypes.bool,
};

export default MainMenuLink;
